import { withLayout } from '../../../layout';

import TeamPage from './team.page';

export default withLayout(TeamPage);
